// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
.btn-nbia-default, .btn-nbia-i-cart, .btn-nbia-i-default, .btn-nbia-li-default {
  border: solid #cccccc 1px;
  background-color: #ffffff;
  height: calc(32px + 2px);
  outline: none;
  user-select: none;
  box-shadow: none !important;
  -webkit-touch-callout: none;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
}

.btn-nbia-default:hover, .btn-nbia-i-cart:hover, .btn-nbia-i-default:hover, .btn-nbia-li-default:hover {
  border: solid #adadad 1px;
  background-color: #e6e6e6;
}

.btn-nbia-default:disabled, .btn-nbia-i-cart:disabled, .btn-nbia-i-default:disabled, .btn-nbia-li-default:disabled {
  border: solid #d3d2d2 1px;
  background-color: #f4f3f3;
}

.btn-nbia-li-default {
  /* T R B L */
  padding: 0px 7px 1px 7px;
  margin: 0 7px 0 7px;
  max-height: 45px;
}

.btn-nbia-i-default {
  /* T R B L */
  padding: 2px 7px 1px 7px;
  margin: 0 7px 0 7px;
  max-width: 30px;
  max-height: 25px;
}

.btn:disabled {
  cursor: not-allowed;
}

.btn-nbia-i-cart {
  /* T R B L */
  padding: 2px 7px 1px 7px;
  margin: 0 7px 0 7px;
  max-width: 30px;
  max-height: 25px;
}

.btn-nbia-i-cart:hover {
  background-color: lightcoral;
}

.card-nbia-header, .card-nbia-header-default, .card-nbia-header-with-icon, .card-nbia-header-with-icon-default, .card-nbia-header-danger {
  padding-bottom: 0;
  border-top-left-radius: 3px;
  border-top-right-radius: 3px;
}

.card-nbia-header-with-icon, .card-nbia-header-with-icon-default, .card-nbia-header-danger {
  height: 58px;
}

.card-nbia-header-danger {
  background-color: #f2dede;
  color: #a94442;
  border-bottom: solid #ebccd1 1px;
}

.card-nbia-danger {
  border-color: #ebccd1;
  border-radius: 3px;
}

.card-nbia-header-default {
  height: 43px;
  background-color: #d9edf7;
  color: #347391;
  border-color: #bce8f1;
  border-bottom: solid #bce8f1 1px;
}

.card-nbia-header-with-icon-default {
  background-color: #d9edf7;
  color: #347391;
  border-color: #bce8f1;
  border-bottom: solid #bce8f1 1px;
}

.card-nbia-default {
  border-color: #bce8f1;
  border-radius: 3px;
}

/* Space between menu bar and top of content */
.dark-row {
  background-color: #f4f4f4;
}

.cart-child-selected {
  background-color: #ff7 !important;
}

.redCart {
  background-color: lightcoral;
}

.greenCart, .cart-selected {
  background-color: aquamarine !important;
}

/* Cart button on Cart screen */
.cart-button {
  padding: 2px 7px 1px 7px;
  margin: 0 7px 0 7px;
}

/* Trying to clean this up for Chrome */
.no-outline, .nbia-button {
  outline: none;
}

.child-data-display {
  background-color: #fff;
  border: solid 1px #e7e7e7;
  /*  Show some parent background */
  margin: 8px 8px 16px 8px;
  /* Child display */
  padding: 6px;
  /*           h-offset   v-offset   blur    spread   color          */
  box-shadow: 6px 6px 12px 0 rgba(0, 0, 0, 0.2), 0 10px 24px 0 rgba(0, 0, 0, 0.15);
  border-radius: 5px;
}

.child-data-display-parent-background {
  background-color: #edf8fb;
}

/*  TODO  explain  */
.alert-box-div {
  z-index: 21;
  position: absolute;
  /* Set the vertical location of all the Alert/Message boxes.  */
  margin-top: 100px;
}

.alert-box-shadow {
  box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19);
}

.alert-box-button {
  float: right;
  margin-left: 4px;
}

.alert-box-icon {
  font-size: x-large;
}

.hide-item {
  display: none;
}

.nbia-loading-label {
  color: #fff;
  /*background-color: #00f8f8;*/
  font-size: 12pt;
}

/*Odd and even, but skipping the top row (Heading)*/
tr:nth-child(even) {
  background: #fff;
}

tr:nth-child(2n+3) {
  background: #f4f4f4;
}

.nbia-drop-down > li:nth-child(even) {
  background: #f4f4f4;
}

.nbia-drop-down > li:nth-child(2n+3) {
  background: #fff;
}

.nbia-drop-down {
  min-width: 60px;
}

.nbia-drop-down > li > a:hover {
  /*background: #baffff;*/
  background: #dde8eb;
}

.busy-pointer {
  cursor: wait;
}

.disabled-busy-check {
  color: #999;
  cursor: wait;
}

.disabled-check {
  color: #aaa;
  cursor: default;
}

.cart-td {
  width: 94px;
  border-left: none;
  margin-right: 0px;
  margin-left: 0px;
  padding-right: 0px;
  padding-left: 0px;
}

/* ********* Buttons ******** */
.nbia-button {
  color: #fff;
  background-color: #0b7983;
  cursor: pointer;
  /*
  font-size: 10pt;
  */
}

.nbia-button:hover {
  background-color: #277599;
}

.nbia-button:active {
  background-color: #1e5975;
}

.nbia-button-disabled:active {
  cursor: not-allowed;
  background-color: #70a4bd;
  color: #f5fafa;
}

.nbia-button-disabled:hover {
  cursor: not-allowed;
  background-color: #70a4bd;
}

.nbia-button-disabled {
  cursor: not-allowed;
  background-color: #70a4bd;
}

.clicker {
  cursor: pointer;
}

.search-results-cart-count {
  background-color: #5b5151;
  color: #fff;
  border-radius: 3px;
  padding: 3px 6px 3px 6px;
  /*margin-left: 2px;*/
  margin-left: -5px;
  margin-bottom: 2px;
  font-size: 8pt;
}

.thead-td {
  background-color: #dedddd;
  border: solid 1px #dedddd;
  height: 50px;
  font-weight: bold;
}

/* For first column headers that would otherwise but up against the left edge and look crowded  */
.thead-td1 {
  padding-left: 3px;
}

.footer-colors {
  color: #686868;
}

.number-spinner {
  border: solid 1px #686868;
  border-radius: 3px;
  position: relative;
  top: 0px;
  padding: 0 4px 0 4px;
  margin: 10px 2px 0 4px;
  width: 60px;
  height: 28px;
}

.rows-per-page-spinner {
  color: #686868;
  margin-bottom: 12px;
}

.popup-heading-text {
  font-size: 12pt;
  font-weight: bold;
}

.close-x {
  font-weight: bold;
  font-family: "Arial Black", Gadget, sans-serif;
  color: #800;
  float: right;
}

.unselectable {
  -webkit-touch-callout: none;
  -webkit-user-select: none;
  user-select: none;
}

.application-menu-icon {
  width: 14px;
  height: 14px;
}

.cart-button-icon {
  width: 14px;
  height: 14px;
}

.cart-delete-button-icon {
  height: 20px;
  padding: 0 3px 1px 0;
}

.chevron-right-icon {
  height: 14px;
}

.chevron-down-icon {
  width: 14px;
}

.sort-triangle {
  height: 14px;
}

/* Query builder - This is still in the "What exactly do we want this to do?" phase,  */
.query-builder-label {
  color: #000;
  margin-left: 15pt;
  margin-bottom: 7pt;
  position: relative;
  top: 8px;
  font-size: 12pt;
}

.query-builder-label2 {
  color: #0d95a1;
  margin-left: 15pt;
  font: 15px arial, sans-serif;
}

.query-builder-panel {
  z-index: 20;
  background-color: #fff;
  border-bottom: solid 10px #cfcfcf;
  border-left: solid 1px #cfcfcf;
  border-right: solid 1px #cfcfcf;
  height: 1000px;
}

.query-builder-panel-heading {
  color: #000;
  margin-left: 15pt;
  margin-bottom: 7pt;
  position: relative;
  top: 8px;
  font-size: 12pt;
}

.query-builder-dropdown {
  margin-left: 15pt;
  margin-top: 7pt;
}

.selected-button {
  background-color: aquamarine;
}

/* -------------------------------------------------------------- */
/* -------------------------------------------------------------- */
/* -------------------------------------------------------------- */
/*------------------------------------*\\
    \$NAV
\\*------------------------------------*/
/**
 * Throw any \`ul\` or \`ol\` into horizontal mode, as per csswizardry.com/2011/09/the-nav-abstraction.
   <ul class=nav>
       <li><a href=/>Home</a></li>
       <li><a href=/about>About</a></li>
       <li><a href=/portfolio>Portfolio</a></li>
       <li><a href=/contact>Contact</a></li>
   </ul>
 */
.nav {
  position: relative;
  list-style: none;
  margin-left: 0;
  cursor: default;
}

.nav > li,
.nav > li > a {
  display: inline-block;
  *display: inline;
  zoom: 1;
}

/**
 * Create a vertically stacked nav by extending \`.nav\` with \`.stacked\`.
   <ul class="nav stacked">
       <li><a href=/>Home</a></li>
       <li><a href=/about>About</a></li>
       <li><a href=/portfolio>Portfolio</a></li>
       <li><a href=/contact>Contact</a></li>
   </ul>
 */
.stacked > li {
  display: list-item;
}

.stacked > li > a {
  display: block;
}

/*------------------------------------*\\
    \$FLYOUT
\\*------------------------------------*/
.clear {
  height: 0;
  overflow: hidden;
  display: none;
}

/**
 * Flyouts are pieces of content that fly out of a parent when said parent is hovered.
 * They typically appear bottom-left of the parent.
   <div class=flyout>
       Foo
       <div class=flyout-content>
           <h1>Lorem</h1>
           <p>Ipsum</p>
       </div>
   </div>
 */
.flyout,
.flyout-alt {
  position: relative;
}

.flyout-content {
  /* Position the flyouts off-screen. This is typically better than \`display:none;\`. */
  position: absolute;
  top: 100%;
  left: -99999px;
  /**
   * Even though they are out of document flow, lots of nested flyouts can
   * eventually force scroll bars to appear as they become taller than the viewport.
   * We can undo this effect by giving them zero height.
   */
  height: 0;
  overflow: hidden;
}

/**
 * Bring the flyouts into view when you hover their parents.
 * Two different types of flyout; ‘regular’ (\`.flyout\`) and ‘alternative’ (\`.flyout-alt\`).
 */
/* Regular flyouts sit all the way from the top, flush left. */
.flyout:hover > .flyout-content {
  left: 0;
}

/* Alternative flyouts sit all the way from the left, flush top. */
.flyout-alt:hover > .flyout-content {
  top: 0;
  left: 100%;
}

.flyout:hover > .flyout-content,
.flyout-alt:hover > .flyout-content {
  /* Give the flyouts their height back once they come into view. */
  height: auto;
  overflow: visible;
}

/*------------------------------------*\\
    \$SITE-NAV
\\*------------------------------------*/
/**
 * Site nav specific styling.
 * Extends \`.nav{}\`
 */
.site-nav {
  z-index: 21;
  font-size: 1em;
  /*font-size:0.75em;*/
  font-family: sans-serif;
}

.site-nav a {
  line-height: 1;
  padding: 0.75em;
  /*padding:1em;*/
  background-color: #09f;
  color: #fff;
  white-space: nowrap;
}

/*--- SITE-NAV FLYOUTS ---*/
/**
 * Site nav specific flyouts, extension of \`.flyout\`.
 * Set up some styles to apply and persist when we hover things in the site nav.
 * This allows us to keep parents highlighted as we hover their contained flyouts [1].
 */
.site-nav .flyout:hover > a,
.site-nav .flyout-alt:hover > a,
.site-nav a:hover {
  color: #435704;
  background-color: aquamarine;
}

/**
 * Add an indicator to any flyout parents in the site nav to show there’s a flyout.
 */
.site-nav .flyout-alt > a:after {
  content: " »";
}

/**
 * Here we set up a load of shared borders on the site-nav specific flyouts.
 * The code looks a little scattered but it allows us to cleverly share declarations:
 * We set up a non-existent [1] solid [2] border on all sides of the relevant elements.
 * We can now also change the style [2] and colour [3] of all borders in one go.
 * Now we have set up border colours and styles, we need to just turn the desired borders ‘on’ [4].
 */
.site-nav a,
.site-nav .flyout-content {
  border: 0 solid #fff;
}

.site-nav > li > a {
  border-left-width: 1px; /* [4] */
}

/* The first link in the site-nav doesn’t require a border at all. */
.site-nav > li:first-child > a {
  border: none;
}

.site-nav .flyout-content {
  border-width: 1px 0 0 1px; /* [4] */
}

.site-nav .flyout-content a {
  border-bottom-width: 1px; /* [4] */
}

.site-nav .flyout-alt:hover > .flyout-content {
  /**
   * To account for the 1px top border on the flyout containers, we need to
   * bring the flyouts back up by 1px in this special instance.
   */
  top: -1px;
}

.top-element {
  margin-left: 15pt;
}

/* -------------------------------------------------------------- */
/* -------------------------------------------------------------- */
/* -------------------------------------------------------------- */
.criteria-name {
  width: 100px;
}

.criteria-li {
  border-bottom: solid white 1px;
}

.collapseAll {
  left: 0;
  border: solid 10px;
}

.clickable-color {
  border-right: solid 1px;
  border-color: #ff7e46 !important;
  background-color: #14b !important;
  cursor: pointer;
}

.clickable-color a:hover {
  color: #fff !important;
  background-color: #a33 !important;
}

.user-input {
  width: 100%;
  height: 48px;
  overflow-y: scroll;
  resize: none;
}

.user-input-add-button {
  color: green;
}

.query-delete-button {
  color: darkred;
}

.display-query-part {
  border-radius: 4px;
  border: solid #aaa 1px;
  padding: 4px 6px 5px 5px;
  font-size: 11pt;
  margin: 10px;
}

.display-query-menu-choice {
  color: #000;
  background-color: aquamarine; /*79ffd3*/
}

.display-query-menu-choice-list {
  /*
  margin-left: 5px;
  margin-bottom: 10px;
  */
}

.display-query-user-input {
  color: #000;
  background-color: #79d3ff;
}

.current-menu-criteria-display {
  min-height: 72px;
}

.display-query-td {
  height: 32px;
}

.display-query-table {
  margin: 0px;
}

.display-query-panel-body {
  padding: 1px;
}

/* FIXME this to over ride parent */
/*Odd and even, but skipping the top row (Heading)*/
tr:nth-child(even) {
  background: #fff;
}

tr:nth-child(2n+3) {
  background: #fff;
}`, "",{"version":3,"sources":["webpack://./src/app/image-search/query-section/query-section-tabs/query-builder/query-builder.component.scss","webpack://./src/app/btn-nbia.scss","webpack://./src/app/card-nbia.scss","webpack://./src/app/app.component.scss"],"names":[],"mappings":"AAAA,gBAAgB;ACWhB;EACI,yBAAA;EACA,yBATuB;EAUvB,wBAAA;EAEA,aAAA;EACA,iBAAA;EACA,2BAAA;EACA,2BAAA;EACA,yBAAA;EACA,sBAAA;EACA,qBAAA;ADVJ;;ACaA;EACI,yBAAA;EACA,yBAtB6B;ADYjC;;ACaA;EACI,yBAAA;EACA,yBA1BgC;ADgBpC;;ACcA;EAEI,YAAA;EACA,wBAAA;EACA,mBAAA;EACA,gBAAA;ADZJ;;ACgBA;EAEI,YAAA;EACA,wBAAA;EACA,mBAAA;EACA,eAAA;EACA,gBAAA;ADdJ;;ACiBA;EACI,mBAAA;ADdJ;;ACoBA;EAEI,YAAA;EACA,wBAAA;EACA,mBAAA;EACA,eAAA;EACA,gBAAA;ADlBJ;;ACqBA;EACI,4BAAA;ADlBJ;;AExCA;EACI,iBAAA;EACA,2BAAA;EACA,4BAAA;AF2CJ;;AEvCA;EAEI,YArBgC;AF8DpC;;AEtCA;EAEI,yBAnBuC;EAoBvC,cAnBiC;EAoBjC,gCAAA;AFwCJ;;AErCA;EACI,qBA1BmC;EA2BnC,kBAAA;AFwCJ;;AEpCA;EAEI,YAxCsB;EAyCtB,yBArCwC;EAsCxC,cArCkC;EAsClC,qBAxCoC;EAyCpC,gCAAA;AFsCJ;;AEnCA;EAEI,yBA7CwC;EA8CxC,cA7CkC;EA8ClC,qBAhDoC;EAiDpC,gCAAA;AFqCJ;;AElCA;EACI,qBArDoC;EAsDpC,kBAAA;AFqCJ;;AG3E6B,8CAAA;AAqC7B;EACI,yBAhDa;AH0FjB;;AGvCA;EACI,iCAAA;AH0CJ;;AGvCA;EACI,4BAAA;AH0CJ;;AGvCA;EACI,uCAAA;AH0CJ;;AGvCA,+BAAA;AACA;EACI,wBAAA;EACA,mBAAA;AH0CJ;;AGtCA,uCAAA;AACA;EACI,aAAA;AHyCJ;;AGtCA;EACI,sBAAA;EACA,yBAAA;EAEA,iCAAA;EACA,wBAAA;EAEA,kBAAA;EACA,YAAA;EAEA,oEAAA;EACA,gFAAA;EAGA,kBAAA;AHoCJ;;AGjCA;EACI,yBAAA;AHoCJ;;AGjCA,oBAAA;AACA;EACI,WA7EY;EA8EZ,kBAAA;EAEA,+DAAA;EACA,iBApGQ;AHuIZ;;AGhCA;EACI,4EAAA;AHmCJ;;AGhCA;EACI,YAAA;EACA,gBAAA;AHmCJ;;AGhCA;EACI,kBAAA;AHmCJ;;AGhCA;EACI,aAAA;AHmCJ;;AGhCA;EACI,WAAA;EACA,6BAAA;EACA,eAAA;AHmCJ;;AGhCA,mDAAA;AACA;EACI,gBAAA;AHmCJ;;AGhCA;EACI,mBAAA;AHmCJ;;AGhCA;EACI,mBAAA;AHmCJ;;AGhCA;EACI,gBAAA;AHmCJ;;AGhCA;EACI,eAAA;AHmCJ;;AGhCA;EACI,uBAAA;EACA,mBAAA;AHmCJ;;AGhCA;EACI,YAAA;AHmCJ;;AGhCA;EACI,WAAA;EACA,YAAA;AHmCJ;;AGhCA;EACI,WAAA;EACA,eAAA;AHmCJ;;AGhCA;EACI,WAAA;EAGA,iBAAA;EAGA,iBAAA;EACA,gBAAA;EACA,kBAAA;EACA,iBAAA;AH+BJ;;AG3BA,+BAAA;AACA;EAEI,WAAA;EACA,yBAAA;EACA,eAAA;EACA;;GAAA;AH+BJ;;AG1BA;EACI,yBAAA;AH6BJ;;AG1BA;EACI,yBAAA;AH6BJ;;AG1BA;EACI,mBAAA;EACA,yBAAA;EACA,cAAA;AH6BJ;;AG1BA;EACI,mBAAA;EACA,yBAAA;AH6BJ;;AG1BA;EACI,mBAAA;EACA,yBAAA;AH6BJ;;AGzBA;EACI,eAAA;AH4BJ;;AGzBA;EACI,yBAAA;EACA,WAAA;EACA,kBAAA;EAEA,wBAAA;EACA,oBAAA;EACA,iBAAA;EAGA,kBAAA;EAEA,cAAA;AHwBJ;;AGrBA;EACI,yBAAA;EACA,yBAAA;EACA,YAAA;EACA,iBAAA;AHwBJ;;AGrBA,iGAAA;AACA;EACI,iBAAA;AHwBJ;;AGrBA;EACI,cAAA;AHwBJ;;AGrBA;EACI,yBAAA;EACA,kBAAA;EAEA,kBAAA;EACA,QAAA;EACA,oBAAA;EACA,sBAAA;EACA,WAAA;EACA,YAAA;AHuBJ;;AGpBA;EACI,cAAA;EACA,mBAAA;AHuBJ;;AGpBA;EACI,eAAA;EACA,iBAAA;AHuBJ;;AGpBA;EACI,iBAAA;EACA,8CAAA;EACA,WAlRU;EAmRV,YAAA;AHuBJ;;AGnBA;EACI,2BAAA;EACA,yBAAA;EAIA,iBAAA;AHsBJ;;AGlBA;EACI,WAAA;EACA,YAAA;AHqBJ;;AGjBA;EACI,WAAA;EACA,YAAA;AHoBJ;;AGjBA;EAEI,YAAA;EACA,oBAAA;AHmBJ;;AGfA;EACI,YAAA;AHkBJ;;AGfA;EACI,WAAA;AHkBJ;;AGfA;EACI,YAAA;AHkBJ;;AAzVA,uFAAA;AACA;EACI,WAAA;EACA,iBAAA;EACA,kBAAA;EACA,kBAAA;EACA,QAAA;EACA,eAAA;AA4VJ;;AAzVA;EACI,cAAA;EACA,iBAAA;EACA,4BAAA;AA4VJ;;AAzVA;EACI,WAAA;EACA,sBAAA;EACA,iCAAA;EACA,8BAAA;EACA,+BAAA;EACA,cAAA;AA4VJ;;AAzVA;EACI,WAAA;EACA,iBAAA;EACA,kBAAA;EACA,kBAAA;EACA,QAAA;EACA,eAAA;AA4VJ;;AAzVA;EACI,iBAAA;EACA,eAAA;AA4VJ;;AAzVA;EACI,4BAAA;AA4VJ;;AAzVA,mEAAA;AACA,mEAAA;AACA,mEAAA;AAEA;;uCAAA;AAGA;;;;;;;;EAAA;AASA;EACI,kBAAA;EAGA,gBAAA;EACA,cAAA;EACA,eAAA;AAyVJ;;AAtVA;;EAEI,qBAAA;GAyVF,eAxVE;EACA,OAAA;AAyVJ;;AAtVA;;;;;;;;EAAA;AASA;EACI,kBAAA;AAyVJ;;AAtVA;EACI,cAAA;AAyVJ;;AAtVA;;uCAAA;AAIA;EACI,SAAA;EACA,gBAAA;EACA,aAAA;AAwVJ;;AArVA;;;;;;;;;;EAAA;AAWA;;EAEI,kBAAA;AAwVJ;;AArVA;EACI,oFAAA;EACA,kBAAA;EACA,SAAA;EACA,cAAA;EACA;;;;IAAA;EAKA,SAAA;EACA,gBAAA;AAwVJ;;AArVA;;;EAAA;AAIA,8DAAA;AACA;EACI,OAAA;AAwVJ;;AArVA,kEAAA;AACA;EACI,MAAA;EACA,UAAA;AAwVJ;;AArVA;;EAEI,iEAAA;EACA,YAAA;EACA,iBAAA;AAwVJ;;AArVA;;uCAAA;AAGA;;;EAAA;AAIA;EACI,WAAA;EACA,cAAA;EACA,oBAAA;EACA,uBAAA;AAwVJ;;AArVA;EACI,cAAA;EACA,eAAA;EACA,eAAA;EACA,sBAAA;EACA,WAAA;EACA,mBAAA;AAwVJ;;AArVA,2BAAA;AACA;;;;EAAA;AAKA;;;EAGI,cAAA;EACA,4BAAA;AAwVJ;;AArVA;;EAAA;AAGA;EACI,aAAA;AAwVJ;;AArVA;;;;;;EAAA;AAOA;;EAEI,oBAAA;AAwVJ;;AArVA;EACI,sBAAA,EAAA,QAAA;AAwVJ;;AArVA,oEAAA;AACA;EACI,YAAA;AAwVJ;;AArVA;EACI,yBAAA,EAAA,QAAA;AAwVJ;;AArVA;EACI,wBAAA,EAAA,QAAA;AAwVJ;;AArVA;EACI;;;IAAA;EAIA,SAAA;AAwVJ;;AArVA;EACI,iBAAA;AAwVJ;;AArVA,mEAAA;AACA,mEAAA;AACA,mEAAA;AAEA;EACI,YAAA;AAuVJ;;AApVA;EACI,8BAAA;AAuVJ;;AApVA;EACI,OAAA;EACA,kBAAA;AAuVJ;;AApVA;EACI,uBAAA;EACA,gCAAA;EACA,iCAAA;EACA,eAAA;AAuVJ;;AApVA;EACI,sBAAA;EACA,iCAAA;AAuVJ;;AApVA;EACI,WAAA;EACA,YAAA;EACA,kBAAA;EACA,YAAA;AAuVJ;;AApVA;EACI,YAAA;AAuVJ;;AApVA;EACI,cAAA;AAuVJ;;AAnVA;EACI,kBAAA;EACA,sBAAA;EACA,wBAAA;EACA,eAAA;EACA,YAAA;AAsVJ;;AAlVA;EACI,WAAA;EACA,4BAAA,EAAA,SAAA;AAqVJ;;AAhVA;EACI;;;GAAA;AAsVJ;;AAhVA;EACI,WAAA;EACA,yBAAA;AAmVJ;;AA/UA;EACI,gBAAA;AAkVJ;;AA/UA;EACI,YAAA;AAkVJ;;AA/UA;EACI,WAAA;AAkVJ;;AA/UA;EACI,YAAA;AAkVJ;;AA3UA,mCAAA;AACA,mDAAA;AACA;EAAoB,gBAAA;AA+UpB;;AA9UA;EAAoB,gBAAA;AAkVpB","sourcesContent":["@import '../../../../app.component.scss';\n\n/* Query builder - This is still in the \"What exactly do we want this to do?\" phase,  */\n.query-builder-label {\n    color: #000;\n    margin-left: 15pt;\n    margin-bottom: 7pt;\n    position: relative;\n    top: 8px;\n    font-size: 12pt;\n}\n\n.query-builder-label2 {\n    color: #0d95a1;\n    margin-left: 15pt;\n    font: 15px arial, sans-serif;\n}\n\n.query-builder-panel {\n    z-index: 20;\n    background-color: #fff;\n    border-bottom: solid 10px #cfcfcf;\n    border-left: solid 1px #cfcfcf;\n    border-right: solid 1px #cfcfcf;\n    height: 1000px;\n}\n\n.query-builder-panel-heading {\n    color: #000;\n    margin-left: 15pt;\n    margin-bottom: 7pt;\n    position: relative;\n    top: 8px;\n    font-size: 12pt;\n}\n\n.query-builder-dropdown {\n    margin-left: 15pt;\n    margin-top: 7pt;\n}\n\n.selected-button {\n    background-color: aquamarine;\n}\n\n/* -------------------------------------------------------------- */\n/* -------------------------------------------------------------- */\n/* -------------------------------------------------------------- */\n\n/*------------------------------------*\\\n    $NAV\n\\*------------------------------------*/\n/**\n * Throw any `ul` or `ol` into horizontal mode, as per csswizardry.com/2011/09/the-nav-abstraction.\n   <ul class=nav>\n       <li><a href=/>Home</a></li>\n       <li><a href=/about>About</a></li>\n       <li><a href=/portfolio>Portfolio</a></li>\n       <li><a href=/contact>Contact</a></li>\n   </ul>\n */\n.nav {\n    position: relative;\n\n\n    list-style: none;\n    margin-left: 0;\n    cursor: default;\n}\n\n.nav > li,\n.nav > li > a {\n    display: inline-block;\n    *display: inline;\n    zoom: 1;\n}\n\n/**\n * Create a vertically stacked nav by extending `.nav` with `.stacked`.\n   <ul class=\"nav stacked\">\n       <li><a href=/>Home</a></li>\n       <li><a href=/about>About</a></li>\n       <li><a href=/portfolio>Portfolio</a></li>\n       <li><a href=/contact>Contact</a></li>\n   </ul>\n */\n.stacked > li {\n    display: list-item;\n}\n\n.stacked > li > a {\n    display: block;\n}\n\n/*------------------------------------*\\\n    $FLYOUT\n\\*------------------------------------*/\n\n.clear {\n    height: 0;\n    overflow: hidden;\n    display: none;\n}\n\n/**\n * Flyouts are pieces of content that fly out of a parent when said parent is hovered.\n * They typically appear bottom-left of the parent.\n   <div class=flyout>\n       Foo\n       <div class=flyout-content>\n           <h1>Lorem</h1>\n           <p>Ipsum</p>\n       </div>\n   </div>\n */\n.flyout,\n.flyout-alt {\n    position: relative;\n}\n\n.flyout-content {\n    /* Position the flyouts off-screen. This is typically better than `display:none;`. */\n    position: absolute;\n    top: 100%;\n    left: -99999px;\n    /**\n     * Even though they are out of document flow, lots of nested flyouts can\n     * eventually force scroll bars to appear as they become taller than the viewport.\n     * We can undo this effect by giving them zero height.\n     */\n    height: 0;\n    overflow: hidden;\n}\n\n/**\n * Bring the flyouts into view when you hover their parents.\n * Two different types of flyout; ‘regular’ (`.flyout`) and ‘alternative’ (`.flyout-alt`).\n */\n/* Regular flyouts sit all the way from the top, flush left. */\n.flyout:hover > .flyout-content {\n    left: 0;\n}\n\n/* Alternative flyouts sit all the way from the left, flush top. */\n.flyout-alt:hover > .flyout-content {\n    top: 0;\n    left: 100%;\n}\n\n.flyout:hover > .flyout-content,\n.flyout-alt:hover > .flyout-content {\n    /* Give the flyouts their height back once they come into view. */\n    height: auto;\n    overflow: visible;\n}\n\n/*------------------------------------*\\\n    $SITE-NAV\n\\*------------------------------------*/\n/**\n * Site nav specific styling.\n * Extends `.nav{}`\n */\n.site-nav {\n    z-index: 21;\n    font-size: 1.0em;\n    /*font-size:0.75em;*/\n    font-family: sans-serif;\n}\n\n.site-nav a {\n    line-height: 1;\n    padding: 0.75em;\n    /*padding:1em;*/\n    background-color: #09f;\n    color: #fff;\n    white-space: nowrap;\n}\n\n/*--- SITE-NAV FLYOUTS ---*/\n/**\n * Site nav specific flyouts, extension of `.flyout`.\n * Set up some styles to apply and persist when we hover things in the site nav.\n * This allows us to keep parents highlighted as we hover their contained flyouts [1].\n */\n.site-nav .flyout:hover > a /* [1] */,\n.site-nav .flyout-alt:hover > a /* [1] */,\n.site-nav a:hover {\n    color: #435704;\n    background-color: aquamarine;\n}\n\n/**\n * Add an indicator to any flyout parents in the site nav to show there’s a flyout.\n */\n.site-nav .flyout-alt > a:after {\n    content: \" »\";\n}\n\n/**\n * Here we set up a load of shared borders on the site-nav specific flyouts.\n * The code looks a little scattered but it allows us to cleverly share declarations:\n * We set up a non-existent [1] solid [2] border on all sides of the relevant elements.\n * We can now also change the style [2] and colour [3] of all borders in one go.\n * Now we have set up border colours and styles, we need to just turn the desired borders ‘on’ [4].\n */\n.site-nav a,\n.site-nav .flyout-content {\n    border: 0 /* [1] */ solid /* [2] */ #fff /* [3] */;\n}\n\n.site-nav > li > a {\n    border-left-width: 1px; /* [4] */\n}\n\n/* The first link in the site-nav doesn’t require a border at all. */\n.site-nav > li:first-child > a {\n    border: none;\n}\n\n.site-nav .flyout-content {\n    border-width: 1px 0 0 1px; /* [4] */\n}\n\n.site-nav .flyout-content a {\n    border-bottom-width: 1px; /* [4] */\n}\n\n.site-nav .flyout-alt:hover > .flyout-content {\n    /**\n     * To account for the 1px top border on the flyout containers, we need to\n     * bring the flyouts back up by 1px in this special instance.\n     */\n    top: -1px;\n}\n\n.top-element {\n    margin-left: 15pt;\n}\n\n/* -------------------------------------------------------------- */\n/* -------------------------------------------------------------- */\n/* -------------------------------------------------------------- */\n\n.criteria-name {\n    width: 100px;\n}\n\n.criteria-li {\n    border-bottom: solid white 1px;\n}\n\n.collapseAll {\n    left: 0;\n    border: solid 10px;\n}\n\n.clickable-color {\n    border-right: solid 1px;\n    border-color: #ff7e46 !important;\n    background-color: #14b !important;\n    cursor: pointer;\n}\n\n.clickable-color a:hover {\n    color: #fff  !important;\n    background-color: #a33  !important;\n}\n\n.user-input {\n    width: 100%;\n    height:48px;\n    overflow-y: scroll;\n    resize: none;\n}\n\n.user-input-add-button {\n    color: green;\n}\n\n.query-delete-button {\n    color: darkred;\n\n}\n\n.display-query-part {\n    border-radius: 4px;\n    border: solid #aaa 1px;\n    padding: 4px 6px 5px 5px;\n    font-size: 11pt;\n    margin:10px;\n\n}\n\n.display-query-menu-choice {\n    color: #000;\n    background-color: aquamarine; /*79ffd3*/\n\n\n}\n\n.display-query-menu-choice-list {\n    /*\n    margin-left: 5px;\n    margin-bottom: 10px;\n    */\n}\n\n.display-query-user-input {\n    color: #000;\n    background-color: #79d3ff;\n\n}\n\n.current-menu-criteria-display {\n    min-height: 72px;\n}\n\n.display-query-td{\n    height: 32px;\n}\n\n.display-query-table{\n    margin:0px;\n}\n\n.display-query-panel-body{\n    padding:1px;\n}\n\n.hide-panel{\n\n}\n\n/* FIXME this to over ride parent */\n/*Odd and even, but skipping the top row (Heading)*/\ntr:nth-child(even) {background: #fff}\ntr:nth-child(2n+3) {background: #fff}\n\n","$default-border-color: #cccccc;\n$default-border-hover-color: #adadad;\n$default-border-disabled-color: #d3d2d2;\n\n$default-background-color: #ffffff;\n$default-background-hover-color: #e6e6e6;\n$default-background-disabled-color: #f4f3f3;\n\n$default-height: 32px;\n$default-border-line-width: 1px;\n\n.btn-nbia-default {\n    border: solid $default-border-color $default-border-line-width;\n    background-color: $default-background-color;\n    height: calc(#{$default-height} + #{$default-border-line-width * 2 });\n\n    outline: none;\n    user-select: none;\n    box-shadow: none !important;\n    -webkit-touch-callout: none;\n    -webkit-user-select: none;\n    -moz-user-select: none;\n    -ms-user-select: none;\n}\n\n.btn-nbia-default:hover {\n    border: solid $default-border-hover-color $default-border-line-width;\n    background-color: $default-background-hover-color;\n}\n\n.btn-nbia-default:disabled {\n    border: solid $default-border-disabled-color $default-border-line-width;\n    background-color: $default-background-disabled-color;\n}\n\n// For buttons with just a larger image/icon Cine mode\n.btn-nbia-li-default {\n    @extend .btn-nbia-default;\n    /* T R B L */\n    padding: 0px 7px 1px 7px;\n    margin: 0 7px 0 7px;\n    max-height: 45px;\n}\n\n// For buttons with just an image/icon\n.btn-nbia-i-default {\n    @extend .btn-nbia-default;\n    /* T R B L */\n    padding: 2px 7px 1px 7px;\n    margin: 0 7px 0 7px;\n    max-width: 30px;\n    max-height: 25px;\n}\n\n.btn:disabled{\n    cursor: not-allowed;\n}\n\n\n\n// This for the \"Cart\" page\n.btn-nbia-i-cart {\n    @extend .btn-nbia-default;\n    /* T R B L */\n    padding: 2px 7px 1px 7px;\n    margin: 0 7px 0 7px;\n    max-width: 30px;\n    max-height: 25px;\n}\n\n.btn-nbia-i-cart:hover {\n    background-color: lightcoral;\n}\n\n","$card-nbia-header-height: 43px;\n$card-nbia-header-with-icon-height: 58px;\n\n$card-nbia-header-default-border-color: #bce8f1;\n$card-nbia-header-default-background-color: #d9edf7;\n$card-nbia-header-default-text-color: #347391;\n\n$card-nbia-header-danger-border-color: #ebccd1;\n$card-nbia-header-danger-background-color: #f2dede;\n$card-nbia-header-danger-text-color: #a94442;\n\n\n// Abstract\n.card-nbia-header {\n    padding-bottom: 0;\n    border-top-left-radius : 3px;\n    border-top-right-radius : 3px;\n}\n\n// Abstract\n.card-nbia-header-with-icon {\n    @extend .card-nbia-header;\n    height:  $card-nbia-header-with-icon-height;\n}\n\n.card-nbia-header-danger{\n    @extend .card-nbia-header-with-icon;\n    background-color: $card-nbia-header-danger-background-color;\n    color: $card-nbia-header-danger-text-color;\n    border-bottom: solid $card-nbia-header-danger-border-color 1px;\n}\n\n.card-nbia-danger{\n    border-color: $card-nbia-header-danger-border-color;\n    border-radius : 3px;\n}\n\n\n.card-nbia-header-default{\n    @extend .card-nbia-header;\n    height:  $card-nbia-header-height;\n    background-color: $card-nbia-header-default-background-color;\n    color: $card-nbia-header-default-text-color;\n    border-color: $card-nbia-header-default-border-color;\n    border-bottom: solid $card-nbia-header-default-border-color 1px;\n}\n\n.card-nbia-header-with-icon-default{\n    @extend .card-nbia-header-with-icon;\n    background-color: $card-nbia-header-default-background-color;\n    color: $card-nbia-header-default-text-color;\n    border-color: $card-nbia-header-default-border-color;\n    border-bottom: solid $card-nbia-header-default-border-color 1px;\n}\n\n.card-nbia-default{\n    border-color: $card-nbia-header-default-border-color;\n    border-radius : 3px;\n}\n\n","@import './btn-nbia';\n@import './card-nbia';\n\n$left-section-width: 390px;\n\n$query-criteria-heading-text-color: #bb0e3d;\n$disabled-text: #747474;\n$button-down-background: #dedddd;\n\n$dark-row-color: #f4f4f4;\n\n$alert-top: 100px;\n\n$close-x-red: #800;\n\n// $heading-height: 110px;\n$heading-height: 122px;\n\n// FIXME This only is used for the opener/closer icon\n$heading-margin-bottom: 8px; /* Space between menu bar and top of content */\n\n$header-background-color: #013856;\n\n$legacy-feedback-left: 182px;\n\n$top-logo-height: 41px;\n\n$banner-font-size: 20pt;\n$display-query-top: 10px;\n\n$popup-z-index: 21;\n$loading-screen-z-index: 5;\n$tool-tip-z-index: 2;\n$display-query-z-index: 0; // @TODO explain\n$pie-char-description-popup-z-index: 2;\n$missing-criteria-z-index: 3;\n$search-results-column-selector-z-index: 2;\n$intro-z-index: 3;\n$banner-z-index: 6;\n\n\n%panel-heading-text-color {\n    color: $query-criteria-heading-text-color;\n}\n\n%panel-heading {\n    @extend %panel-heading-text-color;\n    background-color: #fff;\n    font-size: 12pt;\n}\n\n%left-section {\n    width: $left-section-width;\n}\n\n\n.dark-row {\n    background-color: $dark-row-color;\n}\n\n.cart-child-selected {\n    background-color: #ff7 !important;\n}\n\n.redCart {\n    background-color: lightcoral;\n}\n\n.greenCart, .cart-selected {\n    background-color: aquamarine !important;\n}\n\n/* Cart button on Cart screen */\n.cart-button {\n    padding: 2px 7px 1px 7px;\n    margin: 0 7px 0 7px;\n}\n\n\n/* Trying to clean this up for Chrome */\n.no-outline {\n    outline: none;\n}\n\n.child-data-display {\n    background-color: #fff;\n    border: solid 1px #e7e7e7;\n\n    /*  Show some parent background */\n    margin: 8px 8px 16px 8px;\n\n    /* Child display */\n    padding: 6px;\n\n    /*           h-offset   v-offset   blur    spread   color          */\n    box-shadow: 6px 6px 12px 0 rgba(0, 0, 0, 0.2),\n    0 10px 24px 0 rgba(0, 0, 0, 0.15);\n\n    border-radius: 5px;\n}\n\n.child-data-display-parent-background {\n    background-color: #edf8fb;\n}\n\n/*  TODO  explain  */\n.alert-box-div {\n    z-index: $popup-z-index;\n    position: absolute;\n\n    /* Set the vertical location of all the Alert/Message boxes.  */\n    margin-top: $alert-top;\n}\n\n.alert-box-shadow {\n    box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19);\n}\n\n.alert-box-button {\n    float: right;\n    margin-left: 4px;\n}\n\n.alert-box-icon {\n    font-size: x-large;\n}\n\n.hide-item {\n    display: none;\n}\n\n.nbia-loading-label {\n    color: #fff;\n    /*background-color: #00f8f8;*/\n    font-size: 12pt;\n}\n\n/*Odd and even, but skipping the top row (Heading)*/\ntr:nth-child(even) {\n    background: #fff\n}\n\ntr:nth-child(2n+3) {\n    background: #f4f4f4\n}\n\n.nbia-drop-down > li:nth-child(even) {\n    background: #f4f4f4;\n}\n\n.nbia-drop-down > li:nth-child(2n+3) {\n    background: #fff;\n}\n\n.nbia-drop-down {\n    min-width: 60px;\n}\n\n.nbia-drop-down > li > a:hover {\n    /*background: #baffff;*/\n    background: #dde8eb;\n}\n\n.busy-pointer {\n    cursor: wait;\n}\n\n.disabled-busy-check {\n    color: #999;\n    cursor: wait;\n}\n\n.disabled-check {\n    color: #aaa;\n    cursor: default;\n}\n\n.cart-td {\n    width: 94px;\n\n    //    border-color: #ff00dd;\n    border-left: none;\n\n\n    margin-right: 0px;\n    margin-left: 0px;\n    padding-right: 0px;\n    padding-left: 0px;\n\n}\n\n/* ********* Buttons ******** */\n.nbia-button {\n    @extend .no-outline;\n    color: #fff;\n    background-color: #0b7983;\n    cursor: pointer;\n    /*\n    font-size: 10pt;\n    */\n}\n\n.nbia-button:hover {\n    background-color: #277599;\n}\n\n.nbia-button:active {\n    background-color: #1e5975;\n}\n\n.nbia-button-disabled:active {\n    cursor: not-allowed;\n    background-color: #70a4bd;\n    color: #f5fafa;\n}\n\n.nbia-button-disabled:hover {\n    cursor: not-allowed;\n    background-color: #70a4bd;\n}\n\n.nbia-button-disabled {\n    cursor: not-allowed;\n    background-color: #70a4bd;\n}\n\n\n.clicker {\n    cursor: pointer;\n}\n\n.search-results-cart-count {\n    background-color: #5b5151;\n    color: #fff;\n    border-radius: 3px;\n\n    padding: 3px 6px 3px 6px;\n    /*margin-left: 2px;*/\n    margin-left: -5px;\n    //  margin-right: -25px;\n\n    margin-bottom: 2px;\n\n    font-size: 8pt;\n}\n\n.thead-td {\n    background-color: #dedddd;\n    border: solid 1px #dedddd;\n    height: 50px;\n    font-weight: bold;\n}\n\n/* For first column headers that would otherwise but up against the left edge and look crowded  */\n.thead-td1 {\n    padding-left: 3px;\n}\n\n.footer-colors {\n    color: #686868;\n}\n\n.number-spinner {\n    border: solid 1px #686868;\n    border-radius: 3px;\n\n    position: relative;\n    top: 0px;\n    padding: 0 4px 0 4px;\n    margin: 10px 2px 0 4px;\n    width: 60px;\n    height: 28px;\n}\n\n.rows-per-page-spinner {\n    color: #686868;\n    margin-bottom: 12px;\n}\n\n.popup-heading-text {\n    font-size: 12pt;\n    font-weight: bold;\n}\n\n.close-x {\n    font-weight: bold;\n    font-family: \"Arial Black\", Gadget, sans-serif;\n    color: $close-x-red;\n    float: right;\n}\n\n\n.unselectable {\n    -webkit-touch-callout: none;\n    -webkit-user-select: none;\n    -khtml-user-select: none;\n    -moz-user-select: none;\n    -ms-user-select: none;\n    user-select: none;\n}\n\n\n.application-menu-icon{\n    width: 14px;\n    height: 14px;\n}\n\n\n.cart-button-icon{\n    width: 14px;\n    height: 14px;\n}\n\n.cart-delete-button-icon{\n    // width: 14px;\n    height: 20px;\n    padding: 0 3px 1px 0;\n}\n\n\n.chevron-right-icon{\n    height: 14px;\n}\n\n.chevron-down-icon{\n    width: 14px;\n}\n\n.sort-triangle{\n    height: 14px;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
